import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { UpdateSkillVersionRequest } from "../SkillRecord";

import { skillQueryKeys } from "./skillQueryKeys";

interface Args {
  skillId: string;
  version: number;
  request: UpdateSkillVersionRequest;
}

export function useUpdateVersion(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ skillId, version, request }: Args) =>
      skillService.updateVersion(skillId, version, request, { orgId }),
    onSuccess: (_data, { skillId }) => {
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.versions(skillId),
      });
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.org(orgId),
      });
    },
  });
}
